import { render } from "./InfoPickupBox.vue?vue&type=template&id=1fc479a4&scoped=true&ts=true"
import script from "./InfoPickupBox.vue?vue&type=script&lang=ts"
export * from "./InfoPickupBox.vue?vue&type=script&lang=ts"

import "./InfoPickupBox.vue?vue&type=style&index=0&id=1fc479a4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc479a4"]])

export default __exports__